/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Button, Input } from "../../components";

import { NavLink, useNavigate } from "react-router-dom";
import "./login.scss";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { AuthLogin } from "../../utilities";
import { v4 as uuidv4 } from "uuid";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { setupInstantNotifications } from "../../firebase";
import { Form } from "react-bootstrap";
import { UserLogin } from "../../utilities/types";
import { messages } from "../../utilities/Messages";

const uuid = uuidv4();
const getMessage = messages.auth;
const LoginSchema = yup.object().shape({
  loginnumber: yup
    .string()
    .required(getMessage.phone_isNotEmpty)
    .matches(/^[0-9]\d{9}$/, getMessage.phone_matches),
  loginpassword: yup
    .string()
    .required(getMessage.password_isNotEmpty)
    .min(8, getMessage.password_minLength)
    .matches(/^\S+$/, getMessage.password_matches),
});

const LoginPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserLogin>({
    resolver: yupResolver(LoginSchema),
  });

  const { UserRole } = useAppSelector(state => state.verifiedUser);
  const nevigate = useNavigate();
  const [loginButton, setLoginButton] = useState(false);
  const [showPassword, setShowPassword] = useState("false");

  const onSubmit: SubmitHandler<UserLogin> = async data => {
    setLoginButton(true);
    const { loginnumber, loginpassword } = data;
    const payload = { username: loginnumber, password: loginpassword };

    const result = await AuthLogin(payload);

    if (result?.status == "200") {
      nevigate("/verification", {
        state: {
          phone: loginnumber,
          password: loginpassword,
          status: result.status,
          message: result.data.message,
          otpNumber: result.data.data.otpNumber,
        },
      });
    } else {
      toast.error(result?.response?.data.message);
    }
    setLoginButton(false);
  };

  useEffect(() => {
    const initializeNotifications = async () => {
      try {
        const token = await setupInstantNotifications();
        if (token) {
          localStorage.setItem("device-token", token);
        }
      } catch (error) {
        console.error("Error initializing notifications:", error);
      }
    };

    initializeNotifications();

    // Handle navigation after role check
    if (UserRole?.role?.name) {
      nevigate("/verification");
    }

    // Set device UUID if not exists
    if (!localStorage.getItem("device-uuid")) {
      localStorage.setItem("device-uuid", uuid);
    }

    document.body.classList.add("login-page");
    return () => {
      document.body.classList.remove("login-page");
    };
  }, [UserRole?.role?.name, uuid]);
  return (
    <>
      <div className="container">
        <div className="row justify-content-center align-items-center bg-height">
          <div className="col-md-5">
            <div className="card">
              <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <h3 className="card-title text-start">Login</h3>
                  <p className="custom-error-msg mb-0 lh-base"></p>
                  <div className="mb-3 text-start">
                    <label htmlFor="number" className="form-label">
                      Phone Number <small className="text-danger">*</small>
                    </label>
                    <Input
                      type="number"
                      placeholder="Enter Phone Number"
                      id="loginnumber"
                      name="loginnumber"
                      className="form-control"
                      register={register}
                      required
                      onWheel={(e: any) => e.target.blur()}
                      onKeyDown={(e: any) =>
                        ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                      }
                    />
                    {errors.loginnumber && (
                      <span className="error-msg">{errors.loginnumber.message}</span>
                    )}
                  </div>
                  <div className="mb-3 text-start">
                    <label htmlFor="loginpassword" className="form-label">
                      Password <small className="text-danger">*</small>
                    </label>
                    <Input
                      type={showPassword === "true" ? "text" : "password"}
                      placeholder="Password"
                      id="loginpassword"
                      name="loginpassword"
                      className="form-control"
                      register={register}
                      required
                    />
                    <Form.Check
                      onChange={(e: any) =>
                        setShowPassword(showPassword === "false" ? "true" : "false")
                      }
                      label="Show Password"
                      name="showPassword"
                      type="checkbox"
                      id="showPassword"
                      value={showPassword === "false" ? "true" : "false"}
                      checked={showPassword === "false" ? false : true}
                    />
                    {errors.loginpassword && (
                      <span className="error-msg">{errors.loginpassword.message}</span>
                    )}
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6 text-start">
                      <NavLink to="/forgot-password">Forgot Password?</NavLink>
                    </div>
                    <div className="col-md-6 text-end">
                      <Button
                        disabled={loginButton}
                        type="submit"
                        bname={loginButton ? "Loging in..." : "Login"}
                        name="loginbutton"
                        id="loginbutton"
                        className="btn btn-primary rounded-1"
                      />
                    </div>

                    <p className="mb-0 mt-4">
                      Don't have an account? <NavLink to="/sign-up">Signup</NavLink>
                    </p>
                    <p className="mb-0 mt-0">
                      Want to delete account?<NavLink to="/delete-account"> Click Here </NavLink>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export { LoginPage };
